import Paginate from "./paginate";

export default Paginate;
